import React from 'react'
import pic from '../Images/pic.png'
import pic2 from '../Images/pic4.png'
import pic3 from '../Images/pic5.png'
import banner from '../Images/banner.png'

function Banner() {
  return (
    <div className='mt-2'>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={banner} className="d-block w-100" alt="Banner 1" />
                </div>
                {/* <div className="carousel-item">
                    <img src={pic2} className="d-block w-100" alt="Banner 3" />
                </div>
                <div className="carousel-item">
                    <img src={pic3} className="d-block w-100" alt="Banner 4" />
                </div> */}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>


        </div>
    </div>
  )
}

export default Banner